module.exports = __webpack_public_path__ + "img/rotate-left.44cb168f.svg";